import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import IMember from "./memberInterfaceStruct";

type initialMemberListState = {
  members: IMember[];
};

const initialState: initialMemberListState = {
  members: [],
};

export const findMemberListUpdatedApiSlice = createSlice({
  name: "apiSlice",
  initialState,
  reducers: {
    updateMemberList: (state: any, action: PayloadAction<IMember[]>) => {
      console.log("store called", action);
      state.members = action.payload;
    },

    resetParameters: () => {
      console.log("reset store called");
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateMemberList, resetParameters } =
  findMemberListUpdatedApiSlice.actions;

export default findMemberListUpdatedApiSlice.reducer;
